import React from "react";
import Router from "./router/Router";
import { GlobalStyle } from "./GlobalStyle";

function App() {
  return (
    <>
    <GlobalStyle/>
    <Router/>
    </>
  );
}

export default App;
